<template>
  <div class="d-flex flex-column status-node" :class="[indicators.bg, props.link && props.isLinkInteractive && 'link']" @click="openLink">
    <i class="mdp-ExternalLink link-icon" v-if="props.link && props.isLinkInteractive"></i>
    <div class="node-title">
      <span v-if="props.status === NodeStatus.Running"><Spinner></Spinner></span>
      <i class="node-icon" :class="[indicators.icon]" v-else></i>
      <span>{{ props.title }}</span>
    </div>
    <div class="node-body">
      {{ props.description }}
      <div>{{ props.link }}</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { NodeStatus } from "@medapro-types/services/healthChecks";
import { computed } from "vue";
import Spinner from "@common/components/Spinner.vue";

const props = defineProps<{
  title: string;
  description: string;
  status: NodeStatus;
  link: string;
  isLinkInteractive: boolean;
}>();

function openLink() {
  if (props.link) {
    window.open(props.link);
  }
}

const indicators = computed(() => {
  switch (props.status) {
    case NodeStatus.Running:
      return {
        icon: "",
        bg: "bg-status-info"
      };
    case NodeStatus.Error:
      return {
        icon: "mdp-Error",
        bg: "bg-status-error"
      };
    case NodeStatus.Warning:
      return {
        icon: "mdp-Warning1",
        bg: "bg-status-warning"
      };
    case NodeStatus.Success:
      return {
        icon: "mdp-CheckCircle1",
        bg: "bg-status-success"
      };
  }

  return {
    icon: "",
    bg: "bg-status-info"
  };
});
</script>
